import React, { Component } from "react";
import _ from "lodash";
// Externals
import PropTypes from "prop-types";
import classNames from "classnames";

// Material helpers
import { withStyles } from "@material-ui/core";

// Material components
import { Grid, Typography, Paper, Collapse, CardActions, IconButton } from "@material-ui/core";
import { Remove, Add } from "@material-ui/icons";

// Component styles
import styles from "./styles";

class IntentList extends Component {
  state = { collapsed: this.props.collapsed };
  renderConnections() {
    const { connections } = this.props;

    const connectionsTemp = this.props.connections.map(item => item.connectorName);
    const enabledTemp = this.props.enabled.map(item => item.connectorName);
    const both = connectionsTemp.filter(item => enabledTemp.includes(item));
    let isEnabled = false;

    connections.map(item => {
      if (both.includes(item.connectorName)) {
        isEnabled = true;
      }
    });

    const conns = _.filter(connections, connection => {
      return connection.visible;
    });
    if (conns.length === 0) {
      return <Typography variant="h6">There are no connections available</Typography>;
    }

    return (
      <Grid className={this.props.classes.listOfConnectors} container spacing={3}>
        {conns.map((connection, index) => (
          <Grid item key={connection.connectionName + index.toString()}>
            <h2>Task List</h2>
          </Grid>
        ))}
      </Grid>
    );
  }

  toggleConnectiors = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    const { classes, className } = this.props;
    const rootClassName = classNames(classes.root, className);

    return (
      <div className={rootClassName}>
        <Paper className={classes.row} elevation={0}>
          <CardActions className={classes.listHeader} onClick={this.toggleConnectiors}>
            <IconButton aria-expanded={true} aria-label="Show more">
              {!this.state.collapsed ? <Remove /> : <Add />}
            </IconButton>

            <Typography variant="h3">
              <span className={classes.noSelect}>{this.props.name}</span>
            </Typography>

            <Typography className={classes.numberOfConnections}>
              <span>
                {this.props.connections.length > 0
                  ? `${this.props.connections.length} items`
                  : "No connections available"}
              </span>
            </Typography>
          </CardActions>
          <Collapse in={!this.state.collapsed} timeout="auto" unmountOnExit>
            <Grid item xs={12} className={classes.rowContent}>
              {this.renderConnections()}
            </Grid>
          </Collapse>
        </Paper>
      </div>
    );
  }
}

IntentList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  connections: PropTypes.array.isRequired
};

export default withStyles(styles)(IntentList);
